// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blWuvzV4l4C2CrbEGJY_ {
  background-color: #EEEEEE;
}

.zKz7NCXyQQcvPlgIVTs1 {
  background-color: #fff;
  border-bottom: 1px solid #EAECF0;
  padding: 16px 24px;
}


.p7xAEcmcYwZSbADlk2A3 {
  padding: 24px;
}

.p7xAEcmcYwZSbADlk2A3 p {
  margin-bottom: 16px;
  font-size: 14px;
}

.p7xAEcmcYwZSbADlk2A3 ul,
.p7xAEcmcYwZSbADlk2A3 ol {
  margin-bottom: 16px;
  padding-left: 15px;
}

.p7xAEcmcYwZSbADlk2A3 li {
  font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/TnC.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;AACpB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".tnc {\r\n  background-color: #EEEEEE;\r\n}\r\n\r\n.tnc__header {\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #EAECF0;\r\n  padding: 16px 24px;\r\n}\r\n\r\n\r\n.tnc__content {\r\n  padding: 24px;\r\n}\r\n\r\n.tnc__content p {\r\n  margin-bottom: 16px;\r\n  font-size: 14px;\r\n}\r\n\r\n.tnc__content ul,\r\n.tnc__content ol {\r\n  margin-bottom: 16px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.tnc__content li {\r\n  font-size: 14px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tnc": `blWuvzV4l4C2CrbEGJY_`,
	"tnc__header": `zKz7NCXyQQcvPlgIVTs1`,
	"tnc__content": `p7xAEcmcYwZSbADlk2A3`
};
export default ___CSS_LOADER_EXPORT___;
